import { jsx as t, jsxs as h } from "react/jsx-runtime";
import "react";
var r = (i) => /* @__PURE__ */ h("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...i,
  children: [
    /* @__PURE__ */ t("rect", {
      width: 20,
      height: 20,
      fill: "#F5F5F5"
    }),
    /* @__PURE__ */ t("rect", {
      width: 1876,
      height: 988,
      transform: "translate(-454 -952)",
      fill: "white"
    }),
    /* @__PURE__ */ t("path", {
      d: "M7.68129 0H0V20H7.68129H20V0H7.68129Z",
      fill: "#D80027"
    }),
    /* @__PURE__ */ t("path", {
      d: "M10.0002 5.57507L11.0266 8.7339H14.348L11.6609 10.6862L12.6873 13.8451L10.0002 11.8928L7.31301 13.8451L8.33945 10.6862L5.65234 8.7339H8.97375L10.0002 5.57507Z",
      fill: "#FFDA44"
    })
  ]
});
export {
  r as default
};
